import React from 'react';

import scss from './FormTitle.module.scss';

function FormTitle({ title }) {
  return <h2 className={scss.title}>{title}</h2>;
}

export default FormTitle;
